module.exports = __webpack_public_path__ + "img/Fiji.e9fdb7db.svg";